import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { AccessControlConfigDto } from '../../../models/access-control/dto/access-control-config.dto';

export const GET_ACCESS_CONTROL_CONFIGS_QUERY_KEY = (organizationId: string) => [
  organizationId,
  'access-control-configs',
];

export const useGetAccessControlConfigs = (organizationId?: string) => {
  const client = useApiClient();

  return useQuery({
    queryKey: GET_ACCESS_CONTROL_CONFIGS_QUERY_KEY(organizationId || ''),
    enabled: !!organizationId,
    queryFn: () =>
      client.fetchApi<AccessControlConfigDto[], {}>({
        endpoint: `access-control/admin/config/${organizationId}`,
        method: 'GET',
      }),
  });
};
